import { clientFetch } from '~/api/clientFetch';

export type ApplicationConfiguration = {
  application_configuration: {
    application_name: string;
    is_api_integration: boolean;
    logo_image: { url: string };
    partner: { name: string };
  };
};

export async function fetchApplicationConfiguration(
  signOut: () => void
): Promise<ApplicationConfiguration> {
  const response = await clientFetch(
    '/application_configuration',
    {
      method: 'GET',
    },
    signOut
  );
  return response.json();
}
